/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AmountApiDto } from './amount.model';
import { PromotionMarketingContentApiDto } from './promotion-marketing-content.model';

export interface AccommodationV2ApiDto {
  company?: AccommodationV2ApiDto.CompanyEnum;
  code?: string;
  name?: string;
  description?: string;
  thumbnailSmall?: string;
  galleryUrls?: Array<string>;
  seasonalDisclaimer?: string;
  /**
   * The type of accommodation
   */
  accommodationType?: AccommodationV2ApiDto.AccommodationTypeEnum;
  /**
   * The type of room (data-driven from Apttus)
   */
  roomType?: string;
  /**
   * The type of bathroom
   */
  bathroomType?: AccommodationV2ApiDto.BathroomTypeEnum;
  /**
   * The meals included
   */
  mealOptions?: AccommodationV2ApiDto.MealOptionsEnum;
  homestayZone?: string;
  residenceName?: string;
  subjectToAvailability?: boolean;
  schoolCode?: string;
  schoolCountry?: string;
  configType?: string;
  uom?: string;
  minWeeks?: number;
  maxWeeks?: number;
  ageMin?: number;
  multiCurrencyPrice?: Array<AmountApiDto>;
  discount?: AmountApiDto;
  /** @deprecated */
  currency?: string;
  destinationCurrency?: string;
  packageCode?: string;
  pricelist?: string;
  row?: number;
  promotionMarketingContent?: PromotionMarketingContentApiDto;
  startDayOfTheWeek?: number;
  oldPrice?: AmountApiDto;
  /** @deprecated */
  price?: AmountApiDto;
  hasPromotion?: boolean;
}
export namespace AccommodationV2ApiDto {
  export const CompanyEnum = {
    KIL: 'KIL',
    PL: 'PL',
    ALP: 'ALP',
    ESL: 'ESL',
  } as const;
  export type CompanyEnum = (typeof CompanyEnum)[keyof typeof CompanyEnum];
  export const AccommodationTypeEnum = {
    HOMESTAY: 'HOMESTAY',
    RESIDENCE: 'RESIDENCE',
    APARTMENT: 'APARTMENT',
    CAMPUS: 'CAMPUS',
    NO_ACCOMMODATION: 'NO_ACCOMMODATION',
    OTHER: 'OTHER',
  } as const;
  export type AccommodationTypeEnum = (typeof AccommodationTypeEnum)[keyof typeof AccommodationTypeEnum];
  export const BathroomTypeEnum = {
    SHARED: 'SHARED',
    PRIVATE: 'PRIVATE',
  } as const;
  export type BathroomTypeEnum = (typeof BathroomTypeEnum)[keyof typeof BathroomTypeEnum];
  export const MealOptionsEnum = {
    BED_BREAKFAST: 'BED_BREAKFAST',
    HALF_BOARD: 'HALF_BOARD',
    MEAL_PLAN: 'MEAL_PLAN',
    NO_MEALS: 'NO_MEALS',
  } as const;
  export type MealOptionsEnum = (typeof MealOptionsEnum)[keyof typeof MealOptionsEnum];
}
